Logger = require 'app/scripts/debug/logger'

module.exports = Logger.log.bind(Logger)
